/**
 * @fileoverview Centralizes all file system operations related to the .awolf directory,
 * providing consistent access patterns and error handling for reading and writing data.
 */

import * as fs from 'fs'
import * as path from 'path'

export const AWOLF_DIRECTORY_NAME = '.awolf'
export const INDEX_DIRECTORY_NAME = 'indices'
export const HISTORY_FILE_NAME = 'history.jsonl'
export const REDO_FILE_NAME = 'redo.jsonl'
export const SETTINGS_FILE_NAME = 'settings.json'

export interface AwolfPaths {
  root: string
  indices: string
  history: string
  redo: string
  settings: string
}

export function getAwolfPaths(baseDir: string): AwolfPaths {
  const root = path.join(baseDir, AWOLF_DIRECTORY_NAME)
  return {
    root,
    indices: path.join(root, INDEX_DIRECTORY_NAME),
    history: path.join(root, HISTORY_FILE_NAME),
    redo: path.join(root, REDO_FILE_NAME),
    settings: path.join(root, SETTINGS_FILE_NAME),
  }
}

export function ensureAwolfDirs(paths: AwolfPaths) {
  fs.mkdirSync(paths.root, { recursive: true })
  fs.mkdirSync(paths.indices, { recursive: true })
}

export function readJsonFile<T>(filePath: string): T {
  try {
    return JSON.parse(fs.readFileSync(filePath, 'utf8'))
  } catch (error) {
    return {} as T
  }
}

export function writeJsonFile(filePath: string, data: any): void {
  try {
    fs.mkdirSync(path.dirname(filePath), { recursive: true })
    fs.writeFileSync(filePath, JSON.stringify(data, null, 2), 'utf8')
  } catch (error) {
    console.error('Failed to write JSON file:', error)
  }
}

export function readJsonlFile<T>(filePath: string): T[] {
  try {
    const content = fs.readFileSync(filePath, 'utf8')
    if (!content) return []
    return content.split('\n').map((line) => JSON.parse(line))
  } catch (error) {
    return []
  }
}

export function writeJsonlFile(filePath: string, data: any[]): void {
  try {
    fs.mkdirSync(path.dirname(filePath), { recursive: true })
    fs.writeFileSync(filePath, data.map((item) => JSON.stringify(item)).join('\n'), 'utf8')
  } catch (error) {
    console.error('Failed to write JSONL file:', error)
  }
}
